/**
 * Prepends element to given array respecting provided result length limit
 *
 * @param {Array} source
 * @param {*} item
 * @param {Number} limit
 * @return {Array}
 */
export function prependToLimited(source, item, limit) {
    let concatenated = Array.prototype.concat(item, source); 
    
    if (source.length < limit)
        return concatenated;
    else
        return concatenated.slice(0, limit)
}



// WEBPACK FOOTER //
// ./src/utils/array.js